import React from 'react';
import CalendarConfiguration from 'src/pages/Configuration/Calendar/CalendarConfiguration';

const CalendarConfigurationWrapper = () => <CalendarConfiguration hideNavBar />;

export default CalendarConfigurationWrapper;
